import { Injectable } from '@angular/core';
import { StorageKeys } from '../Util/storage-keys';

@Injectable({
    providedIn: 'root',
})

export class LocalStorageService {

    setItem<T = string>(key: string, value: T): void {
        localStorage.setItem(key, JSON.stringify(value));
    }

    getItem<T = string>(key: string): T | null {
        const item = localStorage.getItem(key);
        return item ? JSON.parse(item) as T : null;
    }

    setItemSessionStorage<T = string>(key: string, value: T): void {
        if(key == StorageKeys.SubscriptionId){
            this.setItem(key,value);
        }
        sessionStorage.setItem(key, JSON.stringify(value));
    }

    removeItemSessionStorage(key: string): void {
        this.removeItem(key)
        sessionStorage.removeItem(key);
    }

    getItemSessionStorage<T = string>(key: string): T | null {
        const item = sessionStorage.getItem(key);
        if(item == null){
          return this.getItem(key)
        }
        return item ? JSON.parse(item) as T : null;

        
    }


    removeItem(key: string): void {
        localStorage.removeItem(key);
    }

    clear(): void {
        localStorage.clear();
    }

    getLength(): number {
        return localStorage.length;
    }

    removeItems(keys: string[]): void {
        keys.forEach(key => localStorage.removeItem(key));
    }

    getAllKeys(): string[] {
        return Object.keys(localStorage);
    }

}
